import { Config } from 'app/config.const';
import { NgbDatepickerI18n, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';
import { isNumber, toInteger, padNumber } from '@ng-bootstrap/ng-bootstrap/util/util';

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

	private static readonly I18N_VALUES = {
		it: {
			dateFormat: 'dd/mm/yyyy',
			weekdays: ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'],
			months: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
		}
	};

	getWeekdayShortName(weekday: number): string {
		return CustomDatepickerI18n.I18N_VALUES[Config.language].weekdays[weekday - 1];
	}

	getMonthShortName(month: number): string {
		return CustomDatepickerI18n.I18N_VALUES[Config.language].months[month - 1];
	}

	getMonthFullName(month: number): string {
		return this.getMonthShortName(month);
	}
}


@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {

	parse(value: string): NgbDateStruct {
		if (value) {
			const dateParts = value.trim().split('-');
			if (dateParts.length === 1 && isNumber(dateParts[0])) {
				return { year: toInteger(dateParts[0]), month: null, day: null };
			} else if (dateParts.length === 2 && isNumber(dateParts[0]) && isNumber(dateParts[1])) {
				return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: null };
			} else if (dateParts.length === 3 && isNumber(dateParts[0]) && isNumber(dateParts[1]) && isNumber(dateParts[2])) {
				return { year: toInteger(dateParts[0]), month: toInteger(dateParts[1]), day: toInteger(dateParts[2]) };
			}
		}
		return null;
	}

	format(date: NgbDateStruct): string {
		return date ?
			`${isNumber(date.day) ? padNumber(date.day) : ''}/${isNumber(date.month) ? padNumber(date.month) : ''}/${date.year}`
			: '';
	}
}



// WEBPACK FOOTER //
// ./src/app/model/datepicker.ts